/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Barva pozadí',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Plná',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Celá šířka',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Šířka obsahu',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Úzká',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Úzká',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Široká',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Široká',
  'company-hub.section-extension.config-panel.preamble':
    'Uspořádejte si prvky do přizpůsobitelných sekcí. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'Další informace o navrhování centra',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Uspořádejte si související prvky do sekcí s přizpůsobitelným pozadím a stylem.',
  'company-hub.section-extension.config-panel.title': 'Sekce',
  'company-hub.section-extension.error-loading-content': 'Chyba při načítání obsahu',
  'company-hub.section-extension.manifest.content.header': 'Dejte své sekci název',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Zástupný znak',
  'company-hub.section-extension.manifest.content.sub-header':
    'Uspořádejte si prvky do sekcí s přizpůsobitelným pozadím.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Sekce',
  'company-hub.section-extension.manifest.extension-title': 'Sekce [nové]',
  'company-hub.section-extension.manifest.macro-description': 'Prvky jsou seskupeny dohromady spolu s pozadím.',
};
